import { componentQrl, inlinedQrl, _jsxBranch, useStore, _jsxQ, _fnSignal, useLexicalScope, _jsxC, _IMMUTABLE, _wrapProp } from "@builder.io/qwik";
import { Blocks } from "../../components/blocks/blocks.qwik.mjs";
const activeTabContent = function activeTabContent2(props, state, active) {
  return props.tabs && props.tabs[active].content;
};
const onClick = function onClick2(props, state, index) {
  if (index === state.activeTab && props.collapsible)
    state.activeTab = -1;
  else
    state.activeTab = index;
};
const Tabs = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  const state = useStore({
    activeTab: props.defaultActiveTab ? props.defaultActiveTab - 1 : 0
  });
  return /* @__PURE__ */ _jsxQ("div", null, null, [
    /* @__PURE__ */ _jsxQ("div", null, {
      class: "builder-tabs-wrap",
      style: _fnSignal((p0) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: p0.tabHeaderLayout || "flex-start",
        overflow: "auto"
      }), [
        props
      ], '{display:"flex",flexDirection:"row",justifyContent:p0.tabHeaderLayout||"flex-start",overflow:"auto"}')
    }, (props.tabs || []).map((tab, index) => {
      return /* @__PURE__ */ _jsxQ("span", {
        class: `builder-tab-wrap ${state.activeTab === index ? "builder-tab-active" : ""}`,
        onClick$: /* @__PURE__ */ inlinedQrl((event) => {
          const [index2, props2, state2] = useLexicalScope();
          return onClick(props2, state2, index2);
        }, "Tabs_component_div_div_span_onClick_hSTBabAHGks", [
          index,
          props,
          state
        ]),
        style: {
          ...state.activeTab === index ? props.activeTabStyle : {}
        }
      }, null, /* @__PURE__ */ _jsxC(Blocks, {
        get parent() {
          return props.builderBlock.id;
        },
        path: `tabs.${index}.label`,
        get blocks() {
          return tab.label;
        },
        get context() {
          return props.builderContext;
        },
        get registeredComponents() {
          return props.builderComponents;
        },
        get linkComponent() {
          return props.builderLinkComponent;
        },
        [_IMMUTABLE]: {
          blocks: _wrapProp(tab, "label"),
          context: _fnSignal((p0) => p0.builderContext, [
            props
          ], "p0.builderContext"),
          linkComponent: _fnSignal((p0) => p0.builderLinkComponent, [
            props
          ], "p0.builderLinkComponent"),
          parent: _fnSignal((p0) => p0.builderBlock.id, [
            props
          ], "p0.builderBlock.id"),
          registeredComponents: _fnSignal((p0) => p0.builderComponents, [
            props
          ], "p0.builderComponents")
        }
      }, 3, "6k_0"), 0, index);
    }), 1, null),
    activeTabContent(props, state, state.activeTab) ? /* @__PURE__ */ _jsxQ("div", null, null, /* @__PURE__ */ _jsxC(Blocks, {
      get parent() {
        return props.builderBlock.id;
      },
      get path() {
        return `tabs.${state.activeTab}.content`;
      },
      blocks: activeTabContent(props, state, state.activeTab),
      get context() {
        return props.builderContext;
      },
      get registeredComponents() {
        return props.builderComponents;
      },
      get linkComponent() {
        return props.builderLinkComponent;
      },
      [_IMMUTABLE]: {
        context: _fnSignal((p0) => p0.builderContext, [
          props
        ], "p0.builderContext"),
        linkComponent: _fnSignal((p0) => p0.builderLinkComponent, [
          props
        ], "p0.builderLinkComponent"),
        parent: _fnSignal((p0) => p0.builderBlock.id, [
          props
        ], "p0.builderBlock.id"),
        path: _fnSignal((p0) => `tabs.${p0.activeTab}.content`, [
          state
        ], "`tabs.${p0.activeTab}.content`"),
        registeredComponents: _fnSignal((p0) => p0.builderComponents, [
          props
        ], "p0.builderComponents")
      }
    }, 3, "6k_1"), 1, "6k_2") : null
  ], 1, "6k_3");
}, "Tabs_component_MhWcxXy0lMY"));
export {
  Tabs,
  activeTabContent,
  Tabs as default,
  onClick
};
